import jwtAuthAxios from 'app/services/auth/jwtAuth'
const teacherServices = {}

function normalizeTeacherLookup(t) {
    if (t == null || typeof t !== 'object') return t
    // DevExtreme lookups expect camelCase keys (valueExpr: 'id').
    const rawId = t.id ?? t.Id
    const id = rawId != null && rawId !== '' ? String(rawId) : rawId
    const firstName = t.firstName ?? t.FirstName
    const lastName = t.lastName ?? t.LastName
    return {
        ...t,
        id,
        firstName,
        lastName,
    }
}

/** API returns either a bare array or { data: [...], totalCount } (ResponsePage). */
function unwrapTeacherLookupRows(payload) {
    if (payload == null) return []
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload.data)) return payload.data
    if (Array.isArray(payload.Data)) return payload.Data
    return []
}

/**
 * @param {Object} filter
 * @param {string} [filter.firstName] — passed as query `search` (prefix match on server)
 * @param {string[]} [filter.includeIds] — teacher ids to merge into the list (10 + these)
 */
teacherServices.getTeacherLookupList = async (filter = {}) => {
    const params = new URLSearchParams()
    if (filter.firstName) {
        params.set('search', filter.firstName)
    }
    const ids = filter.includeIds
    if (Array.isArray(ids)) {
        for (const id of ids) {
            if (id != null && id !== '') {
                params.append('includeIds', String(id))
            }
        }
    }
    const qs = params.toString()
    const url = `/api/Teacher/lookup/list${qs ? `?${qs}` : ''}`
    const { data } = await jwtAuthAxios.get(url, filter).catch(function (error) {
        if (error.response) {
            throw error.response.data
        } else if (error.request) {
            console.log(error.request)
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    const rows = unwrapTeacherLookupRows(data)
    return rows.map(normalizeTeacherLookup)
}

teacherServices.getTeacherById = async (key) => {
    let url = `/api/Teacher/lookup/${key}`
    const { data } = await jwtAuthAxios.get(url, '').catch(function (error) {
        if (error.response) {
            throw error.response.data
        } else if (error.request) {
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return normalizeTeacherLookup(data)
}

export default teacherServices
